export default __webpack_public_path__ + "static/media/07_photo.df179b00.jpeg";